<template>
  <div>
    <md-table
      :value="tableData"
      :md-sort.sync="currentSort"
      :md-sort-order.sync="currentSortOrder"
      :md-sort-fn="customSort"
      class="paginated-table table-striped table-hover table-bordered"
      md-fixed-header
    >
      <md-table-toolbar>
        <md-field>
          <label>Per page</label>
          <md-select v-model="pagination.perPage" name="pages">
            <md-option
              v-for="item in perPageOptions"
              :key="item"
              :label="item"
              :value="item"
            >
              {{ item }}
            </md-option>
          </md-select>
        </md-field>
      </md-table-toolbar>
      <md-table-row slot="md-table-row" slot-scope="{ item }">
        <!-- eslint-disable -->
        <md-table-cell
          v-for="(column, key) in columns"
          :key="key"
          :md-label="column"
          :md-sort-by="key"
        >
          <div v-if="key === 'avatar'" class="news-thumbnail">
            <progressive-img
              :src="item[key]"
              fallback="img/faces/logo.png"
              v-if="item[key]"
            />
            <p v-else>N/A</p>
          </div>
          <span v-else>
            {{ item[key] }}
          </span>
        </md-table-cell>
        <!-- eslint-enable -->
        <md-table-cell v-if="!hideAction" md-label="Actions">
          <md-button
            class="md-just-icon md-info md-simple"
            @click.native="showFormView(item)"
          >
            <md-tooltip md-direction="top">{{ $t("common.view") }}</md-tooltip>
            <md-icon>remove_red_eye</md-icon>
          </md-button>
          <md-button
            class="md-just-icon md-danger md-simple"
            @click.native="confirmDelete(item)"
          >
            <md-tooltip md-direction="top">{{
              $t("common.delete")
            }}</md-tooltip>
            <md-icon>close</md-icon>
          </md-button>
        </md-table-cell>
      </md-table-row>
    </md-table>
  </div>
</template>

<script>
import _ from "lodash";

export default {
  name: "NewsTable",
  data() {
    return {
      perPageOptions: [5, 10, 25, 50],
      currentSort: "name",
      currentSortOrder: "asc",
      searchQuery: ""
    };
  },
  components: {},
  props: ["tableData", "pagination", "columns", "hideAction"],
  mounted() {},
  methods: {
    customSort(value) {
      return value.sort((a, b) => {
        const sortBy = this.currentSort;
        if (this.currentSortOrder === "desc") {
          if (_.isNumber(a[sortBy]) && _.isNumber(b[sortBy])) {
            return a[sortBy]
              .toString()
              .localeCompare(b[sortBy].toString(), undefined, {
                numeric: true
              });
          }
          return a[sortBy].localeCompare(b[sortBy]);
        }
        if (_.isNumber(a[sortBy]) && _.isNumber(b[sortBy])) {
          return b[sortBy]
            .toString()
            .localeCompare(a[sortBy].toString(), undefined, {
              numeric: true
            });
        }
        return b[sortBy].localeCompare(a[sortBy]);
      });
    },
    showFormView(item) {
      this.$router.push({
        path: (this.currentRoutePath + "/" + item.id + "/view").replace(
          "//",
          "/"
        )
      });
      this.$emit("showForm", item, "view");
    },

    confirmDelete(item) {
      this.$emit("confirmDelete", item);
    },
    isDisplay(column) {
      if (!this.columns) return true;
      return this.columns[column];
    }
  },
  computed: {
    currentRoutePath() {
      return this.$route.path;
    }
  }
};
</script>

<style scoped="scss">
.md-table-cell {
  word-break: break-all;
}
.news-thumbnail {
  padding: 2px 0;
  max-width: 130px;
  max-height: 60px;
}
</style>
